import RegisterForm from '../auth/RegisterForm'

const Register = () => {
  return (
    <RegisterForm />
  )
}

export default Register
